import { useAuth } from "@allergy123/auth-client/react";
import { Card } from "@allergy123/ui";

export function AccountPage() {
  const { session } = useAuth();
  return (
    <>
      <h1 className="mb-8 text-h1 font-semibold text-anchor">Account</h1>
      <Card className="max-w-[560px]">
        <dl className="grid grid-cols-[max-content_1fr] gap-x-6 gap-y-3">
          <dt className="text-small font-medium text-ink-secondary">Name</dt>
          <dd>{session?.claims.name ?? "—"}</dd>
          <dt className="text-small font-medium text-ink-secondary">Email</dt>
          <dd>{session?.claims.email ?? "—"}</dd>
          <dt className="text-small font-medium text-ink-secondary">Products</dt>
          <dd>{session?.claims.groups.length ? session.claims.groups.join(", ") : "—"}</dd>
        </dl>
        <p className="mt-6 text-small text-ink-secondary">Password and two-step verification are managed on the sign-in page.</p>
      </Card>
    </>
  );
}
